// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type MoneyBackGuarantee40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const MoneyBackGuarantee40: FC<MoneyBackGuarantee40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M6.111 13.333H33.89V9.444H6.11v3.89ZM3.333 9.444c0-.75.276-1.4.827-1.951.55-.551 1.201-.827 1.951-.827H33.89c.75 0 1.4.276 1.951.827.551.55.827 1.201.827 1.951v9.972H6.11v11.14h8.75v2.777h-8.75c-.75 0-1.4-.275-1.951-.826-.551-.551-.827-1.202-.827-1.952V9.445Zm21.584 27.222-7.084-7.083 1.972-1.972 5.112 5.083 9.805-9.805 1.945 2.027-11.75 11.75ZM6.11 9.444v21.111-6.889 5.18V9.445Z" />
        </svg>
    );
};

export default MoneyBackGuarantee40;
